import { render, staticRenderFns } from "./dimensionEdit.vue?vue&type=template&id=5c08f896&"
import script from "./dimensionEdit.vue?vue&type=script&lang=js&"
export * from "./dimensionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports